import React from 'react'
import PropTypes from 'prop-types'
import HrbTranslate from '../../../../components/language/HrbTranslate'

const Divider = ({ textKey }) => 
    <div className='message-container columns'>
        <div className='dashed column is-10 is-offset-1'>
            <span><HrbTranslate text={textKey} /></span>
        </div>
    </div>

Divider.propTypes = {
    textKey: PropTypes.string.isRequired
}

export default Divider